// can be used in both client and server, client has the value of PUBLIC_URL injected on build
export const getDevsiteFullPath = (path: string) => {
  if (process.env.PUBLIC_URL) {
    return `${process.env.PUBLIC_URL}${path}`;
  }

  return path;
};
